import { NavLink } from "react-router-dom";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactNode } from "react";

interface LinkTileCardProps {
  to: string;
  icon: ReactNode;
  title: string;
  subtitle: string;
}

const LinkTileCard = ({ to, icon, title, subtitle }: LinkTileCardProps) => {
  return (
    <Card variant="outlined">
      <CardActionArea component={NavLink} to={to}>
        <CardContent>
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            wrap="nowrap"
          >
            <Grid
              sx={{
                minWidth: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "10px",
                  backgroundColor: "rgba(204, 0, 0, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {icon}
              </Grid>
            </Grid>
            <Grid sx={{ flex: 1, textAlign: "left" }}>
              <Typography sx={{ fontSize: "1.2em", fontWeight: "bold" }}>
                {title}
              </Typography>
              <Typography sx={{ color: "text.secondary" }}>
                {subtitle}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default LinkTileCard;
